// Multi-currency display + Stripe settlement helper.
// USD is the primary settlement currency. HKD settles in HKD (real Stripe price).
// EUR/GBP are reference displays only — payment always routes through the USD price.

export const CURRENCIES = ["usd", "hkd"];

export const FX = {
  usd: { symbol: "$", rate: 1, label: "USD $" },
  hkd: { symbol: "HK$", rate: 7.8, label: "HKD $" },
};

// Resolve display amount + symbol + Stripe lookup_key for a plan in a given currency.
// HKD → real HKD price. USD/EUR/GBP → USD price (EUR/GBP amounts are reference-only).
export function planDisplay(plan, currency) {
  const usd = plan.prices.usd || {};
  if (currency === "hkd") {
    const hkd = plan.prices.hkd || {};
    return { symbol: "HK$", amount: hkd.amount, lookup_key: hkd.lookup_key, billedInUsd: false };
  }
  const fx = FX[currency] || FX.usd;
  const amount = currency === "usd" ? usd.amount : Math.round((usd.amount || 0) * fx.rate);
  return { symbol: fx.symbol, amount, lookup_key: usd.lookup_key, billedInUsd: currency !== "usd" };
}
